import { POPUP_DIMENSIONS } from '@misc/constants'
import { useTheme } from '@mui/material'
import { getWindowDimensions, isSidePanel } from '@utils/windows'
import { AnimatePresence, motion } from 'framer-motion'
import React, { FC, ReactNode } from 'react'

interface Props {
  visible?: boolean
  children?: ReactNode
  onBackdropClick?: () => void
}

const BottomSheet: FC<Props> = ({ visible, children, onBackdropClick }) => {
  const theme = useTheme()

  const { height } = isSidePanel ? getWindowDimensions() : POPUP_DIMENSIONS

  return (
    <AnimatePresence>
      {visible && (
        <>
          <motion.div
            key="sheetBackdrop"
            style={{
              position: 'fixed',
              bottom: 0,
              left: 0,
              right: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0,0,0,0.5)',
              zIndex: 4,
            }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            onClick={() => onBackdropClick?.()}
          />
          <motion.div
            key="bottom"
            style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              width: '100%',
              backgroundColor: theme.palette.background.default,
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
              zIndex: 5,
            }}
            initial={{ y: height }}
            animate={{ y: 0 }}
            exit={{ y: height }}
            transition={{ duration: 0.3 }}
          >
            {children}
          </motion.div>
        </>
      )}
    </AnimatePresence>
  )
}

export default BottomSheet
